import React, { Component } from 'react';
import FastClone from 'fastest-clone';
import EventsApiClient from '../stores/EventsApiClient';

export default class MetricSelector extends Component {

  constructor(props){
    super(props);
    this.state = this.makeState(props.server, props.category, props.monitor);
    this.triggerChange();
  }

  componentDidMount(){
    var self = this;
    new EventsApiClient().list().then(function (response) {
      var s = self.makeState();
      s.servers = response.data;
      self.setState(s);
    });
  }

  makeState(server, category, monitor)  {

    var s = {};

    if (this.state == null) {
      s.server = server || '';
      s.category = category || '';
      s.monitor = monitor || '';
      s.servers = [];
    } else {
      s = new (FastClone.factory(this.state, true))(this.state);
    }

    return s;

  }

  handleServerChange = (e) => {
    var s = this.makeState();
    s.server = e.target.value;
    s.category = '';
    s.monitor = '';
    this.setState(s, this.triggerChange);
  }

  handleCategoryChange = (e) => {
    var s = this.makeState();
    s.category = e.target.value;
    s.monitor = '';
    this.setState(s, this.triggerChange);
  }

  handleMetricChange = (e) => {
    var s = this.makeState();
    s.monitor = e.target.value;
    this.setState(s, this.triggerChange);
  }

  triggerChange () {
      this.props.onChange({target: this});
  }

  render() {

    var serverIndex = -1;
    var categoryIndex = -1;

    var servers = [(<option key={-1}></option>)];
    for (var i = 0; i < this.state.servers.length; i++) {
      if (this.state.servers[i].Name === this.state.server)
        serverIndex = i;
        servers.push(<option key={i}>{this.state.servers[i].Name}</option>);
    }

    var categories = [(<option key={-1}></option>)];
    if (serverIndex >= 0) {
      for (i = 0; i < this.state.servers[serverIndex].Categories.length; i++) {
        if (this.state.servers[serverIndex].Categories[i].Name === this.state.category)
          categoryIndex = i;
          categories.push(<option key={i}>{this.state.servers[serverIndex].Categories[i].Name}</option>);
      }
    }

    var monitors = [(<option key={-1}></option>)];
    if (categoryIndex >= 0) {
      for (i = 0; i < this.state.servers[serverIndex].Categories[categoryIndex].Monitors.length; i++) {
        monitors.push(<option key={i}>{this.state.servers[serverIndex].Categories[categoryIndex].Monitors[i]}</option>);
      }
    }

    return (
      <div className="pad20">
        <div className="row">
          <div className="col-md-4">
            <label>Server: </label>
            <select onChange={this.handleServerChange} value={this.state.server}>{servers}</select>
          </div>
          <div className="col-md-4">
            <label>Category: </label>
            <select onChange={this.handleCategoryChange} value={this.state.category}>{categories}</select>
          </div>
          <div className="col-md-4">
            <label>Name: </label>
            <select onChange={this.handleMetricChange} value={this.state.monitor}>{monitors}</select>
          </div>
        </div>
      </div>
    );
  }

}


// WEBPACK FOOTER //
// ./src/components/MetricSelector.js